import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/index'
import Project from '@/components/project'
import New from '@/components/new'
import About from '@/components/about'
import Recruit from '@/components/recruit'
import Contact from '@/components/contact'
import Newdetails from '@/components/newdetails'
import Business from '@/components/business'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/project',
      name: 'project',
      component: Project
    },
    {
      path: '/new',
      name: 'new',
      component: New
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: Recruit
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/newdetails',
      name: 'newdetails',
      component: Newdetails
    },
    {
      path: '/business',
      name: 'business',
      component: Business
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js